export const fmtNum = (n) => (typeof n === "number" ? n.toLocaleString() : "—");
export const fmtPct = (n) => (typeof n === "number" ? `${n}%` : "—");
export const fmtMin = (m) => {
  if (m == null) return "—";
  const mins = Math.round(m);
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const r = mins % 60;
  return r ? `${h}h ${r}m` : `${h}h`;
};
